import {
    ChangeEventHandler,
    FormEvent,
    ReactElement,
    useState,
} from "react";

interface Props {
    email: string;
    onSubmit: (referralCode?: string) => void;
    initialReferralCode?: string;
    disableReferralField?: boolean
}

function LoginRegistration(props: Props): ReactElement {
    const [confirmations, setConfirmations] = useState({
        age: false,
        terms: false,
    });
    const [referralCode, setReferralCode] = useState<string>(props.initialReferralCode || "");
    const userConfirmedTerms = confirmations.age && confirmations.terms;

    const refCodeOnChange: ChangeEventHandler<HTMLInputElement> = (e) => {
        setReferralCode(e.target.value);
    };

    function submitSignUp(e: FormEvent<HTMLFormElement>): void {
        e.preventDefault();
        props.onSubmit(referralCode);
    }

    return (
        <form onSubmit={submitSignUp}>
            <div className="login-page_content_email-container">
                <label>Email</label>
                <input
                    type="email"
                    required
                    placeholder="Enter your email address"
                    value={props.email}
                    disabled={true}
                />
            </div>

            <div className="login-page_content_referral-container">
                <label>Referral code</label>
                <input
                    placeholder="Enter your referral code (optional)"
                    value={referralCode}
                    disabled={props.disableReferralField}
                    onChange={refCodeOnChange}
                />
            </div>


            <div className="login-page_content_confirm">
                {/*
                 * Native checkbox + <label> wrapper (was the legacy checkbox
                 * background="purple", which is being retired and forced the
                 * legacy purple accent into the new-theme auth modal). The
                 * label makes the whole row a tap target; dp-auth.scss styles
                 * the input to the red accent.
                 */}
                <label className="login-page_content_confirm_field">
                    <input
                        type="checkbox"
                        className="login-page_content_confirm_field_checkbox"
                        checked={confirmations.age}
                        onChange={() => {
                            setConfirmations({
                                ...confirmations,
                                age: !confirmations.age,
                            });
                        }}
                    />
                    <span className="login-page_content_confirm_field_text">
                        I confirm that I am 18 years of age or older.
                    </span>
                </label>
                <label className="login-page_content_confirm_field">
                    <input
                        type="checkbox"
                        className="login-page_content_confirm_field_checkbox"
                        checked={confirmations.terms}
                        onChange={() => {
                            setConfirmations({
                                ...confirmations,
                                terms: !confirmations.terms,
                            });
                        }}
                    />
                    <span className="login-page_content_confirm_field_text">
                        I have read, understood, and agree to the{" "}
                        <a href="/terms-of-use">DevourPlay Terms of Use</a> ,{" "}
                        <a href="/privacy-policy">Privacy Policy</a>, and{" "}
                        <a href="/cookie-policy">Cookie Policy</a> .
                    </span>
                </label>
            </div>

            <button
                type="submit"
                className="login-page_content_login-button"
                disabled={!userConfirmedTerms}
            >
                Create Account
            </button>
        </form>
    );
}

export default LoginRegistration;
